import { render, staticRenderFns } from "./ResumeTooltip.vue?vue&type=template&id=5252a764&scoped=true&"
import script from "./ResumeTooltip.vue?vue&type=script&lang=js&"
export * from "./ResumeTooltip.vue?vue&type=script&lang=js&"
import style0 from "./ResumeTooltip.vue?vue&type=style&index=0&id=5252a764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252a764",
  null
  
)

export default component.exports